export const products_navigation_links: Record<string, string> = {
  banking_all_banking: 'banking-all-banking',
  banking_thrivent_bank: 'banking-thrivent-bank',
  banking_church_loans: 'banking-church-loans',
  investments_annuities: 'investments-annuities',
  investments_mutual_funds: 'investments-mutual-funds',
  insurance_disability_insurance: 'insurance-disability-insurance',
  insurance_life_insurance: 'insurance-life-insurance',
  insurance_long_term_care_strategy: 'insurance-long-term-care-strategy',
  all_products_and_services: 'all-products-and-services',
  banking_banking_title: 'products-banking-title',
  banking_investments_title: 'products-investments-title',
  banking_insurance_title: 'products-insurance-title',
  products_title: 'products-title',
  products_description: 'products-description',
} as const;

export const financial_advice_navigation_links: Record<string, string> = {
  advice_services_free_money_coaching: 'advice-services-free-money-coaching',
  advice_services_dedicated_planning: 'advice-services-dedicated-planning',
  advice_services_managed_accounts: 'advice-services-managed-accounts',
  advice_services_personal_trust: 'advice-services-personal-trust',
  financial_goals_starting_out_financially:
    'financial-goals-starting-out-financially',
  financial_goals_balancing_work_and_family:
    'financial-goals-balancing-work-and-family',
  working_with_a_financial_advisor: 'working-with-a-financial-advisor',
  financial_goals_nearing_retirement: 'financial-goals-nearing-retirement',
  financial_goals_living_in_retirement: 'financial-goals-living-in-retirement',
  financial_advice_advice_services_title: 'advice-services-title',
  financial_advice_advice_goals_title: 'advice-goals-title',
  financial_advice_title: 'financial-advice-title',
  financial_advice_description: 'financial-advice-description',
} as const;

export const resources_navigation_links: Record<string, string> = {
  insights_and_guidance: 'insights-and-guidance',
  financial_education_events: 'financial-education-events',
  market_and_economic_updates: 'market-and-economic-updates',
  tools_and_calculators: 'tools-and-calculators',
  client_resources: 'client-resources',
  contact_us: 'contact-us',
  faqs: 'faqs',
  resources_title: 'resources-title',
  resources_learn_title: 'resources-learn-title',
  resources_get_help_title: 'resources-get-help-title',
  resources_description: 'resources-description',
} as const;
